module.exports = __webpack_public_path__ + "img/logo_thwi.5679d4fd.png";